import React from 'react';
import { Link } from 'react-router-dom';

export const AdminDashboardHeader = ({ onRefresh, onLogout }) => {
  return (
    <div className="bg-white shadow-sm border-b" data-testid="admin-dashboard-header">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/" className="text-gray-600 hover:text-gray-900" data-testid="admin-dashboard-back-link">
            ← Voltar
          </Link>
          <h1 className="text-xl font-bold text-gray-900" data-testid="admin-dashboard-title">⚙️ Painel Administrativo</h1>
        </div>

        <div className="flex items-center gap-2" data-testid="admin-dashboard-header-actions">
          <Link
            to="/admin/vendedores"
            className="px-4 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition"
            data-testid="admin-dashboard-vendedores-link"
          >
            👥 Vendedores
          </Link>
          <button
            onClick={onRefresh}
            className="px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
            data-testid="admin-dashboard-refresh-button"
          >
            🔄 Atualizar
          </button>
          <button
            onClick={onLogout}
            className="px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition"
            data-testid="admin-dashboard-logout-button"
          >
            🚪 Sair
          </button>
        </div>
      </div>
    </div>
  );
};
